import { render, staticRenderFns } from "./TransferCodStatement.vue?vue&type=template&id=1c9d1675"
import script from "./TransferCodStatement.vue?vue&type=script&lang=js"
export * from "./TransferCodStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports